const global = {
  domain: 'lexiangspace.com',
  base: {
    url: '//www.lexiangspace.com/api',
    api: '//www.lexiangspace.com/api'
  },
  file: {
    url: '//www.lexiangspace.com/api'
  },
  fileTypeMimes: {
    'Attach': '*',
    'Image': 'image/gif,image/jpeg,image/bmp,image/png',
    'Pdf': 'application/pdf',
    'Excel': 'application/vnd.ms-excel',
    'ImgPdf': 'image/gif,image/jpeg,image/bmp,image/png,application/pdf'
  }
}

export default global
